import React from 'react';
import classnames from 'classnames';

import Icon from '../../../common/components/icon/Icon';

import './RoutablePointMarkerIcon.scss';

export interface RoutablePointMarkerIconProps {
  className?: string;
  label?: string;
  active?: boolean;
}

const RoutablePointMarkerIcon = ({
  className,
  label,
  active,
}: RoutablePointMarkerIconProps) => {
  return (
    <div
      className={classnames(
        'routable-point-marker-icon',
        { 'routable-point-marker-icon_active': active },
        className,
      )}
    >
      <Icon name="marker-circle" />
      <div className="routable-point-marker-icon__label">{label}</div>
    </div>
  );
};

export default RoutablePointMarkerIcon;
